
export default {
  name: 'VsAlert',
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'info'
    },
    animateAppear: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    closeText: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: 'tint'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    icon: {
      fontSize: 'lg',
      $theme: {
        color(value) {
          return value == 'solid' ? 'white' : this.color
        }
      }
    },
    close: {
      $extend: 'icon',
      fontSize: 'xs'
    }
  },
  data() {
    return {
      visible: true
    }
  },
  computed: {
    color() {
      const types = { error: 'danger', alert: 'info' }
      return types[this.type] || this.type
    },
    attrs() {
      const backgrounds = {
        solid:   this.color,
        tint:    `${this.color}-light`,
        hollow:  'white',
        outline: 'white'
      }

      const colors = {
        solid:   'white',
        tint:    this.color,
        hollow:  this.color,
        outline: 'black'
      }

      return {
        width: 'full',
        borderRadius: true,
        padding: 'xs',
        fontSize: 'sm',
        backgroundColor: backgrounds[this.theme],
        color: colors[this.theme],
        ...this.$attrs
      }
    },
    iconName() {
      const icons = {
        primary: 'question-circle',
        info:    'info-circle',
        success: 'check-circle',
        warning: 'exclamation-circle',
        danger:  'times-circle'
      }

      return this.icon || icons[this.color]
    },
    contentTitle() {
      return this.contentText == this.title ? null : this.title
    },
    contentText() {
      return this.text || this.description || this.title
    }
  },
  methods: {
    onClose() {
      this.visible = false
      this.$emit('close')
    }
  }
}
